module.exports = __webpack_public_path__ + "static/cat-black-56c38db80038d3a582899fb0b4f579f1.png";